const dsSEO = (($) => {

    const grid = 24;
    let categories = [];

    function klaviyoViewedProduct(product) {
        let _learnq = window._learnq || [];
        const item = {
            "ProductName" : product.name,
            "ProductID"   : product.id,
            "Categories"  : product.categories.filter((category) => !['Shop', ''].includes(category)),
            "ImageURL"    : doorstep.image_url + product.image,
            "URL"         : product.href,
            "Brand"       : product.brand,
            "Price"       : product.price
        };
        _learnq.push(["track", "Viewed Product", item]);
        _learnq.push(["trackViewedItem", {
            "Title"    : item.ProductName,
            "ItemId"   : item.ProductID,
            "ImageUrl" : item.ImageURL,
            "Url"      : item.URL,
            "Metadata" : {
                "Brand" : item.Brand,
                "Price" : item.Price
            }
        }]);
    }

    function klaviyoStartCheckout() {
        if (doorstep.cart_products !== undefined) {
            let _learnq = window._learnq || [],
                item_names = [],
                items = [],
                grand_total = 0;
            doorstep.cart_products.forEach(function (product) {
                const product_name = (product.brand + ' ' + product.name).trim();
                let quantity = parseFloat(product.in_cart),
                    price = parseFloat(product.price),
                    total = parseFloat((quantity * price).toFixed(2));
                if (quantity % 1 !== 0) {
                    quantity = Math.ceil(quantity);
                    price = parseFloat((total/quantity).toFixed(2));
                }
                grand_total += total;
                item_names.push(product_name);
                items.push({
                    "ProductID"   : String(product.id),
                    "SKU"         : String(product.fmid),
                    "ProductName" : product_name,
                    "Categories"  : product.categories.filter((category) => !['Shop', ''].includes(category)),
                    "Quantity"    : quantity,
                    "ItemPrice"   : price,
                    "RowTotal"    : total,
                    "ProductURL"  : product.href,
                    "ImageURL"    : product.image
                });
            });
            _learnq.push([
                "track", "Started Checkout", {
                    "$event_id"   : doorstep.customer.id + '_' + moment().format('X'),
                    "$value"      : parseFloat(grand_total),
                    "ItemNames"   : item_names,
                    "CheckoutURL" : doorstep.url + dsUtilities.urlCheckout(),
                    "Items"       : items
                }
            ]);
        }
    }

    function gtmUserType() {
        if (doorstep.user_type.length > 0) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'ecommerce': null });
            window.dataLayer.push({ 'event': 'pageview', 'userType': doorstep.user_type });
        }
    }

    function gtmAddToCart(data) {
        if (doorstep.mode !== 'recurring') {
            let items = [];
            data.forEach(function (product) {
                if (product.quantity > 0) {
                    items.push(gtmItem(product, product.quantity));
                }
            });
            gtmPush({
                'event' : 'add_to_cart',
                'ecommerce' : {
                    'items' : items
                }
            });
        }
    }

    function gtmCheckout(step) {
        step = parseInt(step);
        if (step > 0 && step < 5) {
            if (step > 1) {
                gtmUserType();
            }
            gtmPush({
                'event' : 'begin_checkout',
                'ecommerce' : {
                    'actionField' : { 'step': step },
                    'items'       : gtmCartItems()
                }
            });
        }
    }

    function gtmPaymentCompleted(payload, type = 'cart') {
        const maximum = 50;
        let
            shipping = 0,
            total = type === 'cart' ? payload.total : 0,
            coupon = '',
            vouchers = [],
            products = type === 'cart' ? gtmCartProducts() : [],
            cogs = 0;
        if (type === 'cart' && type !== 'free_delivery' && type !== 'voucher') {
            products.sort((a, b) => (b.quantity * b.price) - (a.quantity * a.price));
            payload.totals.forEach(function (item) {
                if (item.code === 'shipping') {
                    shipping += Math.round(item.value * 100) / 100;
                }
                if (item.code === 'sub_total') {
                    total = Math.round(item.value * 100) / 100;
                }
                if (item.code === 'coupon') {
                    coupon = item.title.substring(7, item.title.length - 1);
                }
                if (item.code === 'voucher') {
                    vouchers.push(item.title.substring(8, item.title.length - 1));
                }
            });
            products.forEach(function (product, i) {
                if (1 < maximum) {
                    cogs += parseFloat((product.quantity * product.cogs).toFixed(2))
                }
            })
        }
        gtmUserType();
        let items = type === 'cart' ? gtmCartItems() : gtmSingleProduct(payload.products[0], payload.total);
        gtmPush({
            'event' : 'purchase',
            'new_customer' : doorstep.user_type === 'new',
            'ecommerce' : {
                'transaction_id' : payload.order_id,
                'value'          : Math.round(total * 100) / 100,
                'tax'            : 0,
                'shipping'       : Math.round(shipping * 100) / 100,
                'currency'       : 'AUD',
                'coupon'         : coupon,
                'vouchers'       : vouchers,
                'zone'           : payload.zone,
                'cogs'           : Math.round(cogs * 100) / 100,
                'items'          : type === 'cart' ? items.slice(0, maximum) : items,
                'enhanced_data'  : {
                    'email'        : payload.customer.email,
                    'phone_number' : payload.customer.mobile.replace(payload.customer.mobile.charAt(0), '+61'),
                    'address'      : {
                        'first_name'  : payload.address.firstname,
                        'last_name'   : payload.address.lastname,
                        'street'      : payload.address.address_full_line,
                        'city'        : payload.address.city,
                        'region'      : payload.address.zone_code,
                        'postal_code' : payload.address.postcode,
                        'country'     : 'Australia',
                    }

                }
            }
        });
    }
    function gtmSingleProduct(product, total) {
        return {
            'id'            : product.fmid,
            'item_id'       : product.fmid,
            'item_name'     : product.name_only,
            'item_brand'    : product.brand,
            'item_category' : getCategory(product),
            'item_variant'  : '',
            'price'         : total,
            'quantity'      : 1,
            'fresh'         : ''
        }
    }

    function gtmProductView(product) {
        gtmPush({
            'event' : 'view_item',
            'ecommerce' : {
                'items' : [gtmItem(product, 1)]
            }
        });
    }

    function gtmProductImpression(page = 1) {
        if (doorstep.products !== undefined) {
            let products = [], nbr = 0;
            let items = [];
            nbr = 0;
            doorstep.products.slice((grid * page) - grid).forEach(function (product) {
                nbr++;
                items.push(gtmItem(product, 1, { 'item_list_name': 'Search Results', 'index' : nbr }));
                product.child_products.forEach(function (child) {
                    nbr++;
                    products.push(gtmItem(child, 1, { 'item_list_name': 'Search Results', 'index' : nbr }));
                });
            });
            gtmPush({
                'event' : 'view_item_list',
                'ecommerce' : {
                    'items' : items
                }
            });
        }
    }

    function writeJavascript(data = []) {
        if (data.length > 0) {
            let script = "<script nonce='" + dsUtilities.cspNonce() + "'>\n";
            data.forEach(function (line) {
                script += line + "\n";
            });
            script += "</script>\n";
            $('body').prepend(script);
        }
    }

    function getUserType() {
        return $.ajax({
            url: dsUtilities.urlCheckout() + '/seo_user_type',
            type: 'get',
            dataType: 'json'
        });
    }

    function gtmRegistration(id) {
        gtmDataLayer({ 'CustomerId' : id });
    }

    function gtmProduct(product, quantity, extra = {}) {
        let price = product.price;
        if (quantity > 0 && quantity % 1 !== 0) {
            const total = parseFloat((quantity * product.price).toFixed(2));
            quantity = Math.ceil(quantity);
            price = parseFloat((total/quantity).toFixed(2));
        }
        let data = {
            'name'     : product.name_only,
            'id'       : product.fmid,
            'price'    : price,
            'brand'    : product.brand,
            'category' : getCategory(product),
            'variant'  : product.size_free,
            'fresh'    : product.fresh,
            'cogs'     : product.cogs
        }
        if (quantity > 0) {
            data.quantity = quantity;
        }
        for (const property in extra) {
            data[property] = extra[property];
        }
        return data;
    }

    // GA4 (new)
    function gtmItem(product, quantity, extra = {}) {
        let price = product.price;
        if (quantity > 0 && quantity % 1 !== 0) {
            const total = parseFloat((quantity * product.price).toFixed(2));
            quantity = Math.ceil(quantity);
            price = total/quantity;
        }
        let data = {
            'id'            : product.fmid,
            'item_id'       : product.fmid,
            'item_name'     : product.name_only,
            'item_brand'    : product.brand,
            'item_category' : getCategory(product),
            'item_variant'  : product.size_free,
            'price'         : parseFloat(price).toFixed(2),
            'fresh'         : product.fresh
        }
        if (quantity > 0) {
            data.quantity = quantity;
        }
        for (const property in extra) {
            data[property] = extra[property];
        }
        return data;
    }

    function gtmCartProducts() {
        let products = [];
        doorstep.cart_products.forEach(function (product) {
            products.push(gtmProduct(product, product.in_cart));
        });
        return products;
    }

    // GA4 (new)
    function gtmCartItems() {
        let items = [];
        doorstep.cart_products.forEach(function (product) {
            items.push(gtmItem(product, product.in_cart));
        });
        return items;
    }

    function gtmPush(data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'ecommerce': null });
        window.dataLayer.push(data);
    }

    function getCategories() {
        let categories = [];
        $('ul#menu a.link').each(function () {
            categories.push($(this).find('p').html());
        });
        return categories;
    }

    function getCategory(product) {
        let cat = '', BreakException = {};
        try {
            categories.forEach(function (category) {
                if (product.categories.includes(category)) {
                    cat = category;
                    throw BreakException;
                }
            });
        } catch (e) {
            if (e !== BreakException) {
                cat = '';
                throw e;
            }
        }
        return cat.trim();
    }

    function gtmDataLayer(data) {
        window.dataLayer = dataLayer || [];
        window.dataLayer.push(data);
    }

    $(document).ready(function () {
        categories = getCategories();
    });

    return {
        klaviyoViewedProduct : klaviyoViewedProduct,
        klaviyoStartCheckout : klaviyoStartCheckout,
        getUserType          : getUserType,
        gtmAddToCart         : gtmAddToCart,
        gtmCheckout          : gtmCheckout,
        gtmPaymentCompleted  : gtmPaymentCompleted,
        gtmRegistration      : gtmRegistration,
        gtmProductView       : gtmProductView,
        gtmProductImpression : gtmProductImpression,
        writeJavascript      : writeJavascript
    }

})(jQuery);